import { render, staticRenderFns } from "./ChannelsTab.vue?vue&type=template&id=190b6688&scoped=true"
import script from "./ChannelsTab.vue?vue&type=script&lang=js"
export * from "./ChannelsTab.vue?vue&type=script&lang=js"
import style0 from "./ChannelsTab.vue?vue&type=style&index=0&id=190b6688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190b6688",
  null
  
)

export default component.exports